export default import.meta.ROLLDOWN_FILE_URL_J1c$YA$e1yBShps3nZNNpg